export enum OrderVarianceKind {
  SkuCount = 'SKU_COUNT',
  OrderValue = 'ORDER_VALUE',
}

export enum OrderVarianceDirection {
  BelowAverage = 'BELOW_AVERAGE',
  AboveAverage = 'ABOVE_AVERAGE',
}

export type VarianceThresholdPercent = '30' | '50' | '75' | '100';
export type MinimumOverdueDays = '0' | '2' | '3' | '7' | '14';

export interface OrderVariance {
  kind: OrderVarianceKind;
  direction: OrderVarianceDirection;
  actualValue: number;
  averageValue: number;
  variancePercent: number;
  thresholdPercent: number;
  currencyCode?: string;
  sampleOrderCount: number;
}

export interface StoreOrderVariance {
  orderId: string;
  orderCode?: string;
  supplierId: string;
  storeId: string;
  variances: OrderVariance[];
}

export interface StoreOrderVariances {
  items: StoreOrderVariance[];
  totalCount?: number;
  estimatedTotalCount?: number;
}

export interface SupplierStoreOrderVariance {
  supplierId: string;
  storeId: string;
  supplierName?: string;
  storeName?: string;
  kind: string;
  averageIntervalDays: number;
  daysSinceLastOrder: number;
  daysOverdue: number;
  thresholdDays: number;
  thresholdPercent: number;
  orderCount: number;
  lastOrderId: string;
  lastOrderCreatedAt: Date;
}

export interface SupplierStoreOrderVariances {
  items: SupplierStoreOrderVariance[];
  totalCount?: number;
  estimatedTotalCount?: number;
}
